// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  UrJobStatusV1,
} from "./types";


export default __t.row({
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
  deletedAt: __t.option(__t.timestamp()).name("deleted_at"),
  id: __t.uuid().primaryKey(),
  brand: __t.uuid(),
  friendlyName: __t.string().name("friendly_name"),
  purchasingPower: __t.option(__t.f64()).name("purchasing_power"),
  get urJobStatus() {
    return __t.option(UrJobStatusV1).name("ur_job_status");
  },
  urJobAttempts: __t.option(__t.u32()).name("ur_job_attempts"),
  urJobLastPolledAt: __t.option(__t.timestamp()).name("ur_job_last_polled_at"),
  urJobCompletedAt: __t.option(__t.timestamp()).name("ur_job_completed_at"),
  urJobErrorKind: __t.option(__t.string()).name("ur_job_error_kind"),
  urJobErrorMessage: __t.option(__t.string()).name("ur_job_error_message"),
  initialQuestionsComplete: __t.bool().name("initial_questions_complete"),
});
